import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useEffect } from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ChevronRight from "@material-ui/icons/ChevronRight";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Favorite from "@material-ui/icons/Favorite";
import { withStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import { blue } from "@material-ui/core/colors";
import InfoIcon from "@material-ui/icons/Info";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import FavoriteBorder from "@material-ui/icons/FavoriteBorder";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import { AccordionDetails, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import FiberManualRecordOutlinedIcon from "@material-ui/icons/FiberManualRecordOutlined";
import Tooltip from "@material-ui/core/Tooltip";
import grey from "@material-ui/core/colors/grey";
import CancelIcon from "@material-ui/icons/Cancel";
import { red } from "@material-ui/core/colors";
// import unmapicon from "./unmap.svg";

const l_grey = grey[300];

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    // padding: `0px ${theme.spacing(3)}px`,
    padding: 0,
  },
  listItem: {
    padding: 0,
  },
  listItemText: {
    flex: "0 1 auto",
    marginRight: "7px",
  },
  body1: {
    fontWeight: "bold",
  },
  listIcon: {
    minWidth: "unset",
    color: "black",
  },
  // arrow: {
  //   color: theme.palette.common.white,
  // },
  // tooltip: {
  //   backgroundColor: theme.palette.common.white,
  // },
  customWidth: {
    color: theme.palette.common.black,
    backgroundColor: theme.palette.common.white,
    boxShadow: "0px 1px 10px black",
    // border: "0.1px solid black",
    maxWidth: 160,
    fontSize: 12,

    // border: "0.5px solid black",
    // color: "black",
  },
  // bulletIcon: {
  //   fontSize: "10px",
  //   marginRight: "5px",
  // },
}));

// function BootstrapTooltip(props) {
//   const classes = useStyles();

//   return <Tooltip arrow classes={classes} {...props} />;
// }

const GreenCheckbox = withStyles({
  root: {
    color: green[400],
    "&$checked": {
      color: green[600],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const BlueCheckbox = withStyles({
  root: {
    color: blue[400],
    "&$checked": {
      color: blue[600],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const Item = (props) => {
  const [data, setData] = React.useState(0);
  const [checkboxchecked, setCheckboxchecked] = React.useState(
    props.arr
      ? props.arr.indexOf(props.dt["label"]) === -1
        ? false
        : true
      : props.dt["checked"] == "y"
      ? true
      : false
  );
  //   const [checkboxchecked, setCheckboxchecked] = React.useState(
  //     props.dt["checked"] == "y" ? true : false
  //   );
  //   const [patharr, setPatharr] = React.useState([]);
  const [recent, setRecent] = React.useState(
    props.dt["mapped"] == "y" ? true : false
  );
  const [map, setMap] = React.useState(
    props.dt["mapped"] == "y" ? true : false
  );
  const [hiding, setHiding] = React.useState(false);
  const [checked, setChecked] = React.useState(
    props.dt["mapped"] == "y" ? true : false
  );
  //   // const [filter, setFilter] = React.useState("");
  //   // const [first, setFirst] = React.useState(isfirst);

  const func = () => {
    if (!hiding) setHiding(!hiding);
  };

  const scndfunc = (boxes) => {
    boxes++;
    //  console.log("boxes", boxes);
    return boxes;
  };

  const temp = () => {
    alert(
      `${props.totalparent.replace(/\s/g, "")}${props.random.replace(
        /\s/g,
        "_"
      )} with type ${typeof props.dt[props.random]}`
    );
    // console.log(props.totalparent);
  };
  var res = new Array();
  var patharr;

  const getpath = (text) => {
    var pos = 0;
    var inipos = 0;
    var ans = "";
    while (pos >= 0 && pos < text.length) {
      pos = text.indexOf(".", pos + 1);
      ans = text.substring(inipos, pos);
      inipos = pos + 1;
      if (pos == -1) break;
      res.push(ans);
    }
    // console.log(res);
    // setPatharr(res);
    patharr = res;
    // return res;
    return
  };

  const modifyjson = (res, json, i, property) => {
    //  console.log("modifyjson called");
    if (res.length < i) {
      //  console.log("empty path");
      return;
    }

     for(let k in json){
       if(!json.hasOwnProperty(k)){
         continue;
       }
      if (json[k] !== null && typeof json[k] === "object") {
        if (k === res[i]) {
          modifyjson(res, json[k], i + 1, property);
        }
      } else {
        if (k === property) {
          if (json[k] === "n") json[k] = "y";
          else json[k] = "n";
          //  console.log("updated", props.samplejson);
          modifyjson(res, json[k], i + 1, property);
          return;
        }
      }
    };
  };
  const handleCheckBoxChange = (x) => {
    if (props.increasenumber && props.decreasenumber) {
      if (checkboxchecked) {
        props.decreasenumber();
      } else {
        props.increasenumber();
      }
    }
    if (props.handleArr) {
      props.handleArr(x);
    }
    setCheckboxchecked(!checkboxchecked);
    getpath(props.totalparent);
  };

  const func2 = () => {
    setMap(true);
    setChecked(true);
  };
  const func3 = () => {
    setMap(false);
    setChecked(false);
    setHiding(false);
  };

  // useEffect(() => {
  //   func2();
  //   func3();
  // }, [checked]);
useEffect(()=>{
  getpath(props.totalparent)
},[props.totalparent])
  //   let tempo = ["personal details", "employe id"];
  return (
    <>
      {/* {getpath(props.totalparent)} */}

      <div
        key={Math.random() * 10}
        style={{
          width: "100%",
          margin: "5px",
          display: "flex",
          alignItems: "center",
          padding: "0px",
        }}
        onClick={() => {
          func();
          getpath(props.totalparent);
        }}
      >
        {props.ischeckbox ? (
          <Checkbox
            style={{
              height: "14px",
              width: "14px",
              marginRight: "11px",
              marginLeft: "0px",
              //   marginBottom: "11px",
            }}
            size="small"
            checked={checkboxchecked}
            onChange={() => {
              handleCheckBoxChange(props.dt["label"]);
              //   modifyjson(patharr, props.samplejson, 0, "checked");
            }}
            onClick={() => {
              !props.arr && modifyjson(patharr, props.samplejson, 0, "checked");
            }}
            color="primary"
            inputProps={{ "aria-label": "primary checkbox" }}
          />
        ) : (
          <FormControlLabel
            control={
              <>
                {recent ? (
                  <GreenCheckbox
                    icon={
                      <FiberManualRecordOutlinedIcon
                        style={{
                          fontSize: "13px",
                          color: "black",
                        }}
                      />
                    }
                    checkedIcon={
                      <FiberManualRecordIcon
                        style={{
                          fontSize: "13px",
                        }}
                      />
                    }
                    checked={checked}
                  />
                ) : map ? (
                  <BlueCheckbox
                    icon={
                      <FiberManualRecordOutlinedIcon
                        style={{
                          fontSize: "13px",
                          color: "black",
                        }}
                      />
                    }
                    checkedIcon={
                      <FiberManualRecordIcon
                        style={{
                          fontSize: "13px",
                        }}
                      />
                    }
                    checked={checked}
                  />
                ) : (
                  <BlueCheckbox
                    icon={
                      <FiberManualRecordOutlinedIcon
                        style={{
                          fontSize: "13px",
                          color: "black",
                        }}
                      />
                    }
                    checkedIcon={
                      <FiberManualRecordIcon
                        style={{
                          fontSize: "13px",
                        }}
                      />
                    }
                    // checked={checked}
                  />
                )}
              </>
            }
            label={""}
          />
        )}
        <span
          style={{
            font: "normal normal normal 12px/17px Open Sans",
            display: "inline-block",
            // marginLeft: "-13px",
          }}
        >
          {props.dt["label"]}
          {/* {console.log(props.random)} */}
          <div
            style={{
              font: "normal normal normal 10px/14px Open Sans",
              color: "#053253",
              float: "right",
              marginLeft: "14px",
            }}
          >
            ({typeof props.dt["value"]})
          </div>
        </span>

        {props.ischeckbox ? (
          ""
        ) : (
          <>
            {hiding ? (
              map ? (
                <button
                  style={{
                    border: "none",
                    display: "inline-flex",
                    alignItems: "center",
                    position: "absolute",
                    right: "35px",
                    background: "none",
                    fontSize: "13px",
                    color: "#D53D3D",
                    top: "15%",
                  }}
                  onClick={() => {
                    func3();
                    modifyjson(patharr, props.samplejson, 0, "mapped");
                  }}
                >
                  Unmap
                  {/* <img
                src={}
                style={{ fontSize: "20px", marginLeft: "2px" }}
                alt=""
              /> */}
                  {/* <CancelIcon></CancelIcon> */}
                </button>
              ) : (
                <button
                  style={{
                    position: "absolute",
                    right: "35px",
                    backgroundColor: "#0072C6",
                    color: "white",
                    top: "15%",
                  }}
                  onClick={() => {
                    func2();
                    modifyjson(patharr, props.samplejson, 0, "mapped");

                    // temp();
                  }}
                >
                  Map
                </button>
              )
            ) : (
              " "
            )}
          </>
        )}
      </div>
    </>
  );
};

export default Item;
